module.exports = __webpack_public_path__ + "static/media/cloud2@2x.81bf5c71.png";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/AttractLoopView/cloud2@2x.png
// module id = 868
// module chunks = 0